define('native/TouchId',[],function () {

    return function (
        touchIdSetupDialog,
        touchIdSettingVM,
        touchIdModel,
        nativeMessenger,
        messageChannels,
        loginModel,
        loginViewModel
    ) {

        var self = this;

        self.showTouchIdSetupIfNeeded = function () {

            // Show the setup dialog if device has ability to be setup but hasn't been yet,
            // and the user has yet to be offered it
            if (
                touchIdModel.deviceHasTouchId()
                && !touchIdModel.deviceIsUsingTouchId()
                && !touchIdModel.hasShownTouchIdOption()
            ) {
                touchIdSetupDialog.show().then(function (touchIdSetupResult) {
                    if (touchIdSetupResult) {
                        touchIdModel.deviceIsUsingTouchId(touchIdSetupResult);
                    }
                });
                touchIdModel.hasShownTouchIdOption(true);
            }
        };

        self.addTouchIdSetting = function (addSettingViewModel) {

            addSettingViewModel(touchIdSettingVM);
        };

        self.loginPageActivated = function () {

            // Show touchid login prompt as long as its been configured and the is not a user
            // selected that is not the touchid user
            if (touchIdModel.shouldShowTouchIdForLogin()) {

                self.showTouchIdPrompt();

            } else if (!touchIdModel.deviceIsUsingTouchId()) {
                // If touchId is not being used on this device remove old
                // credentials when getting to login page
                nativeMessenger.sendMessage(messageChannels.REMOVE_CREDENTIALS);
            }
        };

        self.showTouchIdPrompt = function () {
            nativeMessenger.sendMessage(messageChannels.LOGIN_WITH_TOUCH_ID);
        };

        // Each time we select a new account, check if its the touch id user and show touch id prompt
        loginViewModel.preSelectedCasumoName.subscribe(function () {

            if (touchIdModel.shouldShowTouchIdForLogin()) {

                self.showTouchIdPrompt();
            }
        });
    };
});

